// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_yrIxL"};